import { getState } from 'redux/core'
import request from 'sb-request'
import { constants, mixpanel } from 'common/helpers'


const callVindicia = (data) => {
  const { models: { me: { email } }, misc: { vindiciaUrl } } = getState()
  const { paymentType, shipping, billing, creditCard, giftCard, giftSubscription, ...beginResponseData } = data
  const { vwsArgs, gatewaySessionId, giftCardSession, giftSubscriptionSession, token } = beginResponseData

  mixpanel.track(constants.analyticsEvents.tech.callVindiciaStart)

  // common

  const userFullName = `${billing.firstName} ${billing.lastName}`

  let values = {
    vin_Account_name:                                     userFullName,
    vin_Account_emailAddress:                             email,
    vin_PaymentMethod_billingAddress_name:                userFullName,
    token,
  }

  // TODO @mikediam check scentbird-gweb/web-app/src/redux/actions/payment.js:407 - this is weird missed code
  // if (values.couponCode && isVindiciaCampaign) {
  //   vinFields.AutoBill_Update_campaignCode = values.couponCode
  // }

  // shipping

  if (shipping) {
    values = {
      ...values,
      vin_Account_shippingAddress_addr1:                  shipping.street,
      vin_Account_shippingAddress_city:                   shipping.city,
      vin_Account_shippingAddress_district:               shipping.state,
      vin_Account_shippingAddress_postalCode:             shipping.zipCode,
      vin_Account_shippingAddress_country:                shipping.country,
      vin_Account_shippingAddress_phone:                  shipping.telephone,
    }
  }

  // billing

  values = {
    ...values,
    vin_PaymentMethod_billingAddress_addr1:               billing.street,
    vin_PaymentMethod_billingAddress_city:                billing.city,
    vin_PaymentMethod_billingAddress_district:            billing.state,
    vin_PaymentMethod_billingAddress_postalCode:          billing.zipCode,
    vin_PaymentMethod_billingAddress_country:             billing.country,
  }

  // credit card

  const expDate = creditCard.expDate.replace('/', '')
  const cardExpirationDate = `20${expDate.substr(2)}${expDate.substr(0, 2)}`

  values = {
    ...values,
    vin_PaymentMethod_accountHolderName:                  creditCard.holderName,
    vin_PaymentMethod_creditCard_account:                 creditCard.cardNumber,
    vin_PaymentMethod_creditCard_expirationDate:          cardExpirationDate,
    vin_PaymentMethod_nameValues_cvn:                     creditCard.cvc,
  }

  if ([ constants.paymentTypes.subscriptionAndEcommerce, constants.paymentTypes.ecommerce ].includes(paymentType)) {
    values = {
      ...values,
      giftCardSession,
      vin_Transaction_transactionItems_0_sku:             'Scentbird Ecommerce',
      vin_Transaction_transactionItems_0_name:            'Description',
      vin_Transaction_transactionItems_0_price:           '1.00', // ductape, real price sent in finalize request
      vin_Transaction_transactionItems_0_quantity:        '1',
    }
  }

  // gift card

  if (giftCard) {
    values = {
      ...values,
      giftCardSession,
      vin_Transaction_transactionItems_0_sku:             'Scentbird Gift Card',
      vin_Transaction_transactionItems_0_name:            'Scentbird Gift Card',
      vin_Transaction_transactionItems_0_price:           giftCard.amount / 100, // TODO why not cents?
      vin_Transaction_transactionItems_0_quantity:        '1',
    }
  }

  // gift subscription

  if (giftSubscription) {
    values = {
      ...values,
      giftSubscriptionSession,
    }
  }

  // additional

  // TODO ask @donbeave to rewrite this String to normal Object
  const additionalArgs = {}
  const args = vwsArgs && vwsArgs.split('&') || []
  args.forEach((arg) => {
    const [ key, value ] = arg.split('=')
    additionalArgs[key] = value
  })

  values = {
    ...values,
    vin_ajax: 1,
    vin_WebSession_VID: gatewaySessionId,
    ...additionalArgs,
  }

  return request.post(vindiciaUrl, {
    formData: true,
    sameOrigin: false,
    body: values,
  })
    .then(() => {
      mixpanel.track(constants.analyticsEvents.tech.callVindiciaSuccess)

      return data
    },
    (err) => {
      mixpanel.track(constants.analyticsEvents.tech.callVindiciaError)

      return Promise.reject(err)
    })
}


export default callVindicia
